/* eslint-disable no-console */
import React, { SyntheticEvent } from "react";

import { Toggle } from "@at/design-system-elements";

import { GalleryMediaTabsStyles } from "./gallery-media-tabs.styled";
import { comScorePageViewTrack } from "../../../utils/tracking/tracking-data-utils";
import { useTracking } from "../../../utils/tracking/use-tracking";
import {
  GalleryAsset,
  GalleryMediaTypes,
  getFullScreenTrackingLabel,
} from "../gallery.utils";

export interface GalleryMediaTabsProps {
  selectedMediaType: GalleryMediaTypes;
  setSelectedMediaType: (selectedMediaType: GalleryMediaTypes) => void;
  images: GalleryAsset[];
  hasVideo: boolean;
  hasSpin: boolean;
}

const getTabOptions = ({
  images,
  hasVideo,
  hasSpin,
  selectedMediaType,
}: {
  images: GalleryAsset[];
  hasVideo: boolean;
  hasSpin: boolean;
  selectedMediaType: GalleryMediaTypes;
}) => {
  const tabOptions = [];

  if (images.some((asset) => asset.type === GalleryMediaTypes.IMAGE)) {
    tabOptions.push({
      label: "Images",
      value: GalleryMediaTypes.IMAGE,
      selected: selectedMediaType === GalleryMediaTypes.IMAGE,
    });
  }

  if (hasVideo) {
    tabOptions.push({
      label: "Video",
      value: GalleryMediaTypes.VIDEO,
      selected: selectedMediaType === GalleryMediaTypes.VIDEO,
    });
  }

  if (hasSpin) {
    tabOptions.push({
      label: "360",
      value: GalleryMediaTypes.SPIN,
      selected: selectedMediaType === GalleryMediaTypes.SPIN,
    });
  }

  return tabOptions;
};

export const GalleryMediaTabs = ({
  selectedMediaType,
  setSelectedMediaType,
  images,
  hasVideo,
  hasSpin,
}: GalleryMediaTabsProps) => {
  const { trackEvent } = useTracking();

  const handleTabChange = (event: SyntheticEvent) => {
    const eventTarget = event.target as HTMLInputElement;
    const selectedTab = eventTarget.value as GalleryMediaTypes;
    setSelectedMediaType(selectedTab);
    const trackingLabel =
      selectedTab === GalleryMediaTypes.SPIN
        ? getFullScreenTrackingLabel(selectedTab)
        : `${selectedTab.toLowerCase()}-gallery-tab`;
    trackEvent({ trackingLabel: trackingLabel });
    comScorePageViewTrack();
  };

  const tabOptions = getTabOptions({
    images,
    hasSpin,
    hasVideo,
    selectedMediaType,
  });

  return (
    <>
      {tabOptions.length > 1 && (
        <GalleryMediaTabsStyles>
          <Toggle
            id="gallery-toggle"
            options={tabOptions}
            name="gallery-toggle"
            onInteraction={handleTabChange}
            additionalClass="locationChange"
          />
        </GalleryMediaTabsStyles>
      )}
    </>
  );
};
